import request from '../../utils/requests'

/**
 * Tag: LeaveRecordStudent
 */

const baseUrl ="/api/LeaveRecordStudent";



/**
 * 记上课使用：根据课时ID和课程ID查询请假记录
 * @param {*} body
 * {
 *    CourseId Desc:课程ID:必填 Required:true
 *    ScheduleId Desc:课时ID:必填 Required:true
 *    StudentId Desc:学员Id Required:false
 * }
 */
async function _getLeaveRSForAttend(body) {
  return request(baseUrl+'/getLeaveRSForAttend',{
    method: 'POST',
    body: body,
  });

}



/**
 * 查询请假记录分页
 * @param {*} body
 * {
 *    OrgUserId Desc:老师/助教ID Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    BranchId Desc:校区ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    ClassId Desc:班级ID Required:false
 *    ScheduleTimeStart Desc:请假课时时间-开始

(开始和结束同时存在才会查询) Required:false
 *    ScheduleTimeEnd Desc:请假课时时间-开始

(开始和结束同时存在才会查询) Required:false
 *    LeaveType Desc:请假类型：枚举ELeaveTypeStudent Required:false
 *    LeaveStatus Desc:审批状态 Required:false
 *    CreateTimeStart Desc:申请时间-开始 Required:false
 *    CreateTimeEnd Desc:申请时间-结束 Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _paging(body) {
  return request(baseUrl+'/paging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 批量通过
 * @param {*} body
 * {
 *    IdList Desc:IdList Required:false
 *    ApprOpinion Desc:审批意见 Required:false
 *    BranchId Desc:校区ID Required:true
 * }
 */
async function _batchApproval(body) {
  return request(baseUrl+'/batchApproval',{
    method: 'POST',
    body: body,
  });

}



/**
 * 批量驳回
 * @param {*} body
 * {
 *    IdList Desc:IdList Required:false
 *    ApprOpinion Desc:审批意见 Required:false
 *    BranchId Desc:校区ID Required:true
 * }
 */
async function _batchReject(body) {
  return request(baseUrl+'/batchReject',{
    method: 'POST',
    body: body,
  });

}



/**
 * 批量撤销
 * @param {*} body
 * {
 *    IdList Desc:IdList Required:false
 *    ApprOpinion Desc:审批意见 Required:false
 *    BranchId Desc:校区ID Required:true
 * }
 */
async function _batchRecall(body) {
  return request(baseUrl+'/batchRecall',{
    method: 'POST',
    body: body,
  });

}



/**
 * 查询已通过的请假记录(某课时，某学员，请假状态)
 * @param {*} body
 * {
 *    LeaveRecordStudentId Desc:请假记录 Required:false
 *    BranchId Desc:校区Id Required:false
 *    OrgId Desc:机构Id Required:false
 *    ScheduleId Desc:课时ID Required:false
 *    StudentId Desc:学员ID Required:false
 * }
 */
async function _getLeaveRecordList(body) {
  return request(baseUrl+'/getLeaveRecordList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取学员请假状态统计
 * @param {*} body
 * {
 *    BranchId Desc:校区ID（必填） Required:true
 *    LeaveStatus Desc:请假状态(不填时查全部) Required:false
 *    OrgId Desc:机构ID（后台使用） Required:false
 * }
 */
async function _getLeaveRSStatusStatistics(body) {
  return request(baseUrl+'/getLeaveRSStatusStatistics',{
    method: 'POST',
    body: body,
  });

}
async function _getMakeUpForApprovalLeavePaging(body) {
  return request(baseUrl+'/getMakeUpForApprovalLeavePaging',{
    method: 'POST',
    body: body,
  });

}
async function _getLeaveAndMakeUpRecordPaging(body) {
  return request(baseUrl+'/getLeaveAndMakeUpRecordPaging',{
    method: 'POST',
    body: body,
  });

}


export default{
  _getLeaveRSForAttend,
  _paging,
  _batchApproval,
  _batchReject,
  _batchRecall,
  _getLeaveRecordList,
  _getLeaveRSStatusStatistics,
  _getMakeUpForApprovalLeavePaging,
  _getLeaveAndMakeUpRecordPaging
}




// WEBPACK FOOTER //
// ./src/services/leaveRecordStudent.js